import {useState} from "react";
import {globalMessageHandler, Rules, ValidationErrors, Validator} from "common";
import {ChangePasswordForm} from "./profileAPI";
import {useAppDispatch} from "app/hooks";
import I18n from "i18n-js";
import {changePasswordAsync} from "../../profile/profileSlice";

export interface ChangePasswordFormProps {
  defaultValues?: ChangePasswordForm;
}

export function validateChangePassword(values: ChangePasswordForm) {
  const rules: Rules = {
    password: Validator.rule.string().required(),
    newPassword: Validator.rule.string().min(6).required(),
  };
  return Validator.validate(rules, values, "ChangePassword");
}

export default function useChangePasswordForm({defaultValues}: ChangePasswordFormProps) {
  const [showChangePasswordForm, setShowChangePasswordForm] = useState(false);
  const [changePasswordErrors, setChangePasswordErrors] = useState<ValidationErrors>({});
  const [changePasswordItem, setChangePasswordItem] = useState<ChangePasswordForm>(
    defaultValues || ({} as ChangePasswordForm)
  );
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();

  function onChangePasswordChange(values: ChangePasswordForm) {
    setChangePasswordItem(values);
  }

  async function processChangePassword() {
    setLoading(true);
    const result = validateChangePassword(changePasswordItem);
    setChangePasswordErrors(result.errors);

    if (!result.success) {
      setLoading(false);
      return;
    }

    const response = await dispatch(changePasswordAsync(changePasswordItem));

    setLoading(false);

    if (response.meta.requestStatus === "fulfilled") {
      globalMessageHandler.success(I18n.t("Profile.passwordSuccessChanged"));
      setShowChangePasswordForm(false);
    } else {
      if (response.payload) {
        setChangePasswordErrors(response.payload.form_errors);
      }
    }
  }

  return {
    showChangePasswordForm,
    setShowChangePasswordForm,
    processChangePassword,
    setChangePasswordItem,
    changePasswordItem,
    changePasswordErrors,
    setChangePasswordErrors,
    onChangePasswordChange,
    changePasswordLoading: loading,
  };
}